import { useEffect } from "react";

const QuantcastPixel = ({ label="PageView", orderId, event }) => {
  useEffect(() => {
    window._qevents = window._qevents || [];

    // Inject the Quantcast script if it doesn't already exist
    (function () {
      const elem = document.createElement('script');
        elem.src = (document.location.protocol == "https:" ? "https://secure" : "http://edge") + ".quantserve.com/quant.js";
        elem.async = true;
        elem.type = "text/javascript";
        const scpt = document.getElementsByTagName('script')[0];
        scpt.parentNode.insertBefore(elem, scpt);
    })();

    const eventPayload = {
      qacct: "p-vXc3n0eGxvxS3",
      labels: `_fp.event.${label}`
    };

    // Push tracking event
    window._qevents.push(eventPayload);

    if (label !== "PageView") {
      eventPayload.orderid = orderId;
      eventPayload.event = event;
      eventPayload.event = "refresh";
      window._qevents.push(eventPayload);
    }

  }, [ label ]); // ✅ Runs only once on mount

  return null;
};

export default QuantcastPixel;
